import { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase.js';
import { jsx } from 'react/jsx-runtime';

const ButtonComponent = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  return /*#__PURE__*/jsx(ButtonBase, {
    ref: forwardedRef,
    as: "button",
    type: "button",
    ...props,
    children: children
  });
});
ButtonComponent.displayName = 'Button';
ButtonComponent.__SLOT__ = Symbol('Button');

export { ButtonComponent };
